import { msgid, ngettext, t } from "ttag";

import type { ShortcutGroup } from "./types";

export function getShortcutGroups(): ShortcutGroup[] {
  return [
    {
      columns: 2,
      shortcuts: [
        {
          label: t`Өнөөдөр`,
          value: { type: "relative", value: 0, unit: "day" },
        },
        {
          label: t`Өчигдөр`,
          value: { type: "relative", value: -1, unit: "day" },
        },
        {
          label: t`Өмнөх 7 өдөр`,
          value: { type: "relative", value: -7, unit: "day" },
        },
        {
          label: t`Өмнөх 30 өдөр`,
          value: { type: "relative", value: -30, unit: "day" },
        },
      ],
    },
    {
      label: t`Previous`,
      columns: 3,
      shortcuts: [
        {
          label: ngettext(msgid`Week`, `Weeks`, 1),
          value: { type: "relative", value: -1, unit: "week" },
        },
        {
          label: ngettext(msgid`Month`, `Months`, 1),
          value: { type: "relative", value: -1, unit: "month" },
        },
        {
          label: ngettext(msgid`Year`, `Years`, 1),
          value: { type: "relative", value: -1, unit: "year" },
        },
      ],
    },
    {
      label: t`This`,
      columns: 3,
      shortcuts: [
        {
          label: ngettext(msgid`Week`, `Weeks`, 1),
          value: { type: "relative", value: 0, unit: "week" },
        },
        {
          label: ngettext(msgid`Month`, `Months`, 1),
          value: { type: "relative", value: 0, unit: "month" },
        },
        {
          label: ngettext(msgid`Year`, `Years`, 1),
          value: { type: "relative", value: 0, unit: "year" },
        },
      ],
    },
  ];
}
